import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

import {
  AreaDataOut,
  AreaGetAllDataIn,
  Client,
  PageInfo,
  SortingType,
} from '../../../../api/api-reference';
import { PermissionsEnum } from '../../../../api/api-reference';
import { AuthService } from '../../../../services/auth.service';
import { ClipboardService } from '../../../../services/clipboard.service';
import { SearchComponent } from '../../../core/components/search/search.component';
import { SortComponent } from '../../../core/components/sort/sort.component';
import { PaginationComponent } from '../../../core/components/pagination/pagination.component';
import { AreaSetupComponent } from './area-setup/area-setup.component';
import { ConfirmDialogComponent } from '../../../core/components/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-area-management',
  standalone: true,
  imports: [
    AreaSetupComponent,
    CommonModule,
    SortComponent,
    SearchComponent,
    TranslateModule,
    PaginationComponent,
    ConfirmDialogComponent,
  ],
  templateUrl: './area-management.component.html',
  styleUrl: './area-management.component.scss',
})
export class AreaManagementComponent {
  data: AreaDataOut[] | undefined = [];
  isAddClicked = false;
  isModalOpen = false;
  public pageSize: number = 10;
  public pageNumber: number = 1;
  public lastPageSize: number = 1;
  public currentPage: number = 1;
  public numberOfAreas: number = 0;
  selectedRowId: string | null = null;

  requestData = new AreaGetAllDataIn({
    pageInfo: new PageInfo({ pageSize: this.pageSize, page: this.pageNumber }),
    search: undefined,
    sorting: SortingType.Descending,
  });

  public PermissionsEnum = PermissionsEnum;

  constructor(
    private client: Client,
    private toastr: ToastrService,
    public authService: AuthService,
    public clipboardService: ClipboardService,
  ) {
    this.reloadTable(1);
  }

  toggleModal(reload?: boolean) {
    this.selectedRowId = null;
    this.isAddClicked = !this.isAddClicked;
    if (reload) {
      this.reloadTable();
    }
  }

  onSortOption(selectedSort?: SortingType) {
    if (selectedSort) this.requestData.sorting = selectedSort;
    this.reloadTable();
  }

  handleRowClick(row: AreaDataOut) {
    this.selectedRowId = row.id!;
    if (!this.isModalOpen) {
      this.isAddClicked = true;
    }
  }

  reloadTable(page?: number) {
    this.pageNumber = page || 0;
    if (page) this.requestData!.pageInfo!.page = this.pageNumber;

    this.client.areaQuery(this.requestData).subscribe({
      next: (response) => {
        this.data = response.data;
        this.numberOfAreas = response.count || 0;
        this.lastPageSize = Math.ceil(this.numberOfAreas / this.pageSize);
      },
      error: (err) => {
        this.toastr.error(err);
      },
    });
    this.selectedRowId = null;
  }

  searchChange(searchText: string) {
    this.requestData.search = searchText;
    this.reloadTable(1);
  }

  handleDelete() {
    this.isModalOpen = true;
  }

  confirmDelete(row: string) {
    this.client.deleteArea(row).subscribe({
      next: (response) => {
        this.toastr.success(response);
        this.reloadTable(this.currentPage);
      },
      error: (err) => {
        this.toastr.error(err);
      },
    });
    this.isModalOpen = false;
    this.selectedRowId = null;
    this.isAddClicked = false;
  }
  cancelDelete() {
    this.isModalOpen = false;
    this.selectedRowId = null;
  }
  pageChange(value: number) {
    this.currentPage = value;
    this.reloadTable(this.currentPage);
  }
}
